import React from 'react';
import { UseFormWatch } from 'react-hook-form';

import { Divider, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SignupRequestDTO } from '../../../types/authentication.dto';

type Props = {
  watch: UseFormWatch<SignupRequestDTO>;
  onEditStep: (step: number) => void;
};

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex', flexDirection: 'column', gap: theme.spacing(2) },
  section: { display: 'flex', flexDirection: 'column', gap: theme.spacing(0.5) },
  sectionHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  row: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(1) },
  label: { color: theme.palette.text.secondary },
}));

const SummaryStep: React.FC<Props> = ({ watch, onEditStep }) => {
  const classes = useStyles();
  const values = watch();

  return (
    <div className={classes.root}>
      <section className={classes.section}>
        <div className={classes.sectionHeader}>
          <Typography variant="subtitle1">Identité</Typography>
          <Link component="button" type="button" onClick={() => onEditStep(0)}>
            Modifier l&apos;identité
          </Link>
        </div>
        <div className={classes.row}>
          <Typography className={classes.label}>Prénom</Typography>
          <Typography>{values.firstname}</Typography>
        </div>
        <div className={classes.row}>
          <Typography className={classes.label}>Nom</Typography>
          <Typography>{values.lastname}</Typography>
        </div>
        <div className={classes.row}>
          <Typography className={classes.label}>Adresse mail</Typography>
          <Typography>{values.email}</Typography>
        </div>
      </section>

      <Divider />

      <section className={classes.section}>
        <div className={classes.sectionHeader}>
          <Typography variant="subtitle1">Livraison</Typography>
          <Link component="button" type="button" onClick={() => onEditStep(1)}>
            Modifier la livraison
          </Link>
        </div>
        <div className={classes.row}>
          <Typography className={classes.label}>Téléphone</Typography>
          <Typography>{values.phoneNumber}</Typography>
        </div>
        <div className={classes.row}>
          <Typography className={classes.label}>Adresse</Typography>
          <Typography>{values.address}</Typography>
        </div>
        {values.information && (
          <div className={classes.row}>
            <Typography className={classes.label}>Complément</Typography>
            <Typography>{values.information}</Typography>
          </div>
        )}
        <div className={classes.row}>
          <Typography className={classes.label}>Newsletter</Typography>
          <Typography>{values.newsLetter ? 'Oui' : 'Non'}</Typography>
        </div>
      </section>
    </div>
  );
};

export default SummaryStep;
